import React from 'react';
import tw, { styled } from 'twin.macro';

import { AnimatePresence } from '@sopranodesign/framer-motion';
import { Flex } from '@sopranodesign/pulse-components';

import {
  Composer,
  Body,
  WidgetFooter,
  BurgerMenu,
  Messages as MessagesComponent
} from '../Components/index';
import { RecordSubscriberTyping } from '../../../Components/index';
import { useDelivery, useBot, useJumpToBottom } from '../../../hooks/index';
import { ComposerProvider } from '../../../Providers/index';

const FooterDivider = styled.hr`
  ${tw`m-0 border-gray-200 border-0 border-t w-full border-solid opacity-25`}
`;

const StyledFlex = styled(Flex)`
  button {
    margin: 0.5rem 0;
  }
`;

const StyledContainer = styled(Flex)`
  padding-right: 1.75rem;
`;

const Messages = () => {
  const { sendMessage } = useDelivery();
  const { showPoweredByUbisend, showBurgerMenu } = useBot();
  const { showJump, handleScroll } = useJumpToBottom();

  return (
    <>
      <Body onScroll={handleScroll}>
        <MessagesComponent showJump={showJump} />
      </Body>
      <AnimatePresence>
        {showBurgerMenu && <BurgerMenu handleButtonClick={sendMessage} />}
      </AnimatePresence>
      <ComposerProvider>
        <RecordSubscriberTyping />
        <Composer channel="converse" />
      </ComposerProvider>
      {showPoweredByUbisend ? (
        <>
          <FooterDivider mbNone mtNone />
          <StyledContainer between center background="white" ptSm pbSm pl>
            <div id="chatbot-footer" />
            <WidgetFooter />
          </StyledContainer>
        </>
      ) : (
        <>
          <StyledFlex col>
            <Flex between background="white" center pl pr>
              <div id="chatbot-footer" />
            </Flex>
          </StyledFlex>
        </>
      )}
    </>
  );
};

export default Messages;
